import { render, staticRenderFns } from "./StepComune.vue?vue&type=template&id=51147d79&scoped=true&"
import script from "./StepComune.vue?vue&type=script&lang=js&"
export * from "./StepComune.vue?vue&type=script&lang=js&"
import style0 from "./StepComune.vue?vue&type=style&index=0&id=51147d79&scoped=true&lang=scss&"
import style1 from "./StepComune.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51147d79",
  null
  
)

export default component.exports